import { ISetting } from './../../../../_models/cms/ISetting';
import { SettingService } from './../../../../shared/services/setting.service';
import { IServiceBook } from './../../../../_models/profile-sections/IServiceBook';
import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { ServiceBookService } from './../../../../shared/services/service-book.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-service-book-form',
  templateUrl: './service-book-form.component.html'
})
export class ServiceBookFormComponent implements OnInit {
  year: number = new Date().getFullYear();
  skeleton: boolean = true;
  loading: boolean;
  title: string = 'Add Service Book';
  serviceBook: IServiceBook;
  serviceBookForm: FormGroup;
  id;


  schoolLevels: IKeyValuePair[];
  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IKeyValuePair[];
  transferReasons: IKeyValuePair[];
  transferCategory: IKeyValuePair[];

  setting: ISetting;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private service: ServiceBookService,
    private commonService: CommonService,
    private settingService: SettingService) {
    this.id = this.route.snapshot.paramMap.get('id');

  }

  async ngOnInit() {
    this.createSanctionedPostForm();

    this.setting = await this.settingService.getSetting();
    if (this.setting && !this.setting.isProfile) {
      this.toastrService.warning("profile module closed!");
      this.router.navigate(['/employee']);
    }
    this.bindDropDown();
    if (this.id) this.service.get(this.id).subscribe((response: IServiceBook) => {
      if (response) {
        this.serviceBook = response;
        this.title = 'Edit Service Book';
        this.setValueSanctionedPostForm();
      }
    });

    this.skeleton = false;
  }


  bindDropDown() {

    this.commonService.getSchoolLevels().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schoolLevels = response;
      }
    });

    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });

    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });

    this.commonService.getTransferReasons().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.transferReasons = response;
      }
    });

    this.commonService.getTransferCategories().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.transferCategory = response;
      }
    });
  }

  changeDepartment(value) {
    if (value != 1) {
      this.getSchools(null, value);
    }
  }
  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }
  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number, schoolLevelId?: number) {
    this.commonService.getSchools(districtId, schoolLevelId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  createSanctionedPostForm() {
    this.serviceBookForm = this.fb.group({
      id: ['0'],
      profileId: [''],
      schoolLevelId: ['', Validators.required],
      regionId: [''],
      stateId: [''],
      districtId: [''],
      schoolId: ['', Validators.required],
      designationId: ['', Validators.required],
      durationFrom: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      durationTo: [null, [Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      isPresent: [false, Validators.required],
      transferReasonId: ['', Validators.required],
      isActive: [true, Validators.required],
      leaveCount: ['', Validators.required],
      //transferCategoryId: ['', Validators.required],
    });
  }

  setValueSanctionedPostForm() {

    if (this.serviceBook.school.regionId) {
      this.getStates(this.serviceBook.school.regionId);
    }

    if (this.serviceBook.school.stateId) {
      this.getDistricts(this.serviceBook.school.stateId);
    }

    if (this.serviceBook.school.districtId || this.serviceBook.school.schoolLevelId) {
      this.getSchools(this.serviceBook.school.districtId, this.serviceBook.school.schoolLevelId);
    }

    this.serviceBookForm.patchValue({
      id: this.serviceBook.id,
      profileId: this.serviceBook.profileId,
      schoolLevelId: this.serviceBook.school.schoolLevelId,
      regionId: this.serviceBook.school.regionId,
      stateId: this.serviceBook.school.stateId,
      districtId: this.serviceBook.school.districtId,
      schoolId: this.serviceBook.schoolId,
      designationId: this.serviceBook.designationId,
      durationFrom: this.datePipe.transform(this.serviceBook.durationFrom, 'dd-MM-yyyy'),
      durationTo: this.datePipe.transform(this.serviceBook.durationTo, 'dd-MM-yyyy'),
      isPresent: this.serviceBook.isPresent,
      transferReasonId: this.serviceBook.transferReasonId,
      //transferCategoryId: this.serviceBook.transferCategoryId == null ? "" : this.serviceBook.transferCategoryId,
      leaveCount: this.serviceBook.leaveCount,
      isActive: this.serviceBook.isActive
    });
  }

  save() {
    if (this.serviceBookForm.valid) {
      this.loading = true;
      this.serviceBook = Object.assign({}, this.serviceBookForm.value);
      if (this.id) {
        this.service.update(this.id, this.serviceBook).subscribe(() => {
          this.toastrService.success('service book updated successful');
          this.router.navigate(['/employee/service-book']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.serviceBook).subscribe(() => {
          this.toastrService.success('service book created successful');
          this.router.navigate(['/employee/service-book']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this service book?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('service book deleted successful');
      this.router.navigate(['/employee/service-book']);
    });
  }




}
